import { createContext, useContext } from 'react'

export interface HelpContextValue {
  openHelp: () => void
}

/**
 * Help context — lives in its own non-component module so React Fast Refresh
 * can hot-reload `HelpProvider` cleanly. Pre-v0.7.5 the context + hook lived
 * inline alongside the component, which tripped the
 * `react-refresh/only-export-components` rule.
 */
export const HelpContext = createContext<HelpContextValue | null>(null)

export function useHelp(): HelpContextValue {
  const ctx = useContext(HelpContext)
  if (!ctx) throw new Error('useHelp must be used inside <HelpProvider>')
  return ctx
}
